import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./core/services/store";
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import ApiService from "./core/services/api.service";
//import MockService from "./core/mock/mock.service";
//import { VERIFY_AUTH } from "./core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import install from "./core/plugins/ToastHelper";
Vue.use(install)

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
import VueToast from 'vue-toast-notification';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import 'vue-select/dist/vue-select.css';
//Vue.component('date-picker', VuePersianDatetimePicker);
Vue.use(VuePersianDatetimePicker, {
  name: 'date-picker',
  props: {
      inputFormat: 'YYYY/MM/DD',
      format: 'jYYYY/jMM/jDD',
      editable: false,
      inputClass: 'form-control my-custom-class-name',
      placeholder: 'تاریخ را انتخاب کنید',
      altFormat: 'YYYY/MM/DD',
      color: '#00acc1',
      autoSubmit: true,
      //...  
      //... And whatever you want to set as default 
      //... 
  }
});
Vue.use(require('vue-jalali-moment'));
// Import one of available themes
import 'vue-toast-notification/dist/theme-default.css';
//import 'vue-toast-notification/dist/theme-sugar.css';
// Vue 3rd party plugins
import i18n from "./core/plugins/vue-i18n";
import vuetify from "./core/plugins/vuetify";
import "./core/plugins/portal-vue";
import "./core/plugins/bootstrap-vue";
import "./core/plugins/perfect-scrollbar";
import "./core/plugins/highlight-js";
import "./core/plugins/inline-svg";
import "./core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import sessionHelper from "./helpers/sessionHelper";
import HighchartsVue from 'highcharts-vue'
Vue.use(VueToast);
Vue.use(HighchartsVue)
// API service init
//ApiService.init();

// Remove this to disable mock API
//MockService.init();
import Echo from "laravel-echo";

window.Pusher = require("pusher-js");
window.Echo = new Echo({
  broadcaster: 'pusher',
  key: 'ac8a3144c04cfc84edee',
  cluster: 'eu',
});

router.beforeEach((to, from, next) => {
  // reset config to initial state
  //store.dispatch(RESET_LAYOUT_CONFIG);
  // Ensure we checked auth before each page load.
  // Promise.all([sessionHelper.isUserValid()]).then(next);
  // if(sessionHelper.isUserValid()){
  //   //next(to);
  // }
  // if (to.name !== 'login' && !sessionHelper.isUserValid()) {
  //   next({ name: 'login' });
  // }
  // else {
  //   next()
  // }
  next()

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});
 
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
